import Backbone from 'backbone';

import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';

import { isInPerformanceTab, isInSmartPerformanceTab } from './common-utils';
import footerTemplate from './template/grid-footer.pug';

const i18n = globalContext.require('$/i18n!legacy/global');

class FooterView extends Backbone.View {
  initialize({
    gridType,
    dashboardSettings,
  } = {}) {
    this.showDisclaimer = isInPerformanceTab(gridType) || isInSmartPerformanceTab(gridType);
    this.dashboardSettings = dashboardSettings;
  }

  render() {
    this.el.innerHTML = footerTemplate({
      showDisclaimer: this.showDisclaimer,
      i18n,
    });
    this.dashboardSettings.initializeSkipPreference(this.$('input.checkbox'));
  }
}

export default FooterView;
